var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"upgrade-badge"},[_c('i',{staticClass:"fas fa-lock"}),_vm._v(" อัปเกรด")])
}]

export { render, staticRenderFns }